export default __webpack_public_path__ + "static/media/darkPlus.daea8c31.svg";